import { useQuery } from "@tanstack/react-query";
import { fetchLanguages } from "features/languages/fetchLanguages";
import { useEffect } from "react";
import { useCatalogsStore } from "stores/catalogs";

export const useLanguagesData = () => {
  const setLanguages = useCatalogsStore((state) => state.setLanguages);

  const { data, isSuccess, isError } = useQuery({
    queryKey: ["languages"],
    queryFn: fetchLanguages,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  if (isError) {
    return;
  }

  useEffect(() => {
    if (isSuccess && data) {
      const updatedList = data.filter((language) => language?.isoCode !== "MM");
      setLanguages(updatedList);
    }
  }, [isSuccess, data, setLanguages]);
};
